import { render, staticRenderFns } from "./WidgetPage.vue?vue&type=template&id=269da59b&"
import script from "./WidgetPage.vue?vue&type=script&lang=js&"
export * from "./WidgetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports